<div class="h-full w-full flex flex-col overflow-y-auto scrollbar-transparent">
    <div class="space-y-8">
        <div>
            <h2 class="text-base/7 font-semibold text-primary">Basic Information</h2>
            <p class="text-sm/6 text-secondary">Screening Brief essential information.</p>

            <div class="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 px-2">
                <div class="sm:col-span-3">
                    <label for="first-name" class="block text-sm/6 font-medium text-primary">Brief title</label>
                    <div class="mt-2">
                        <input [formField]="createScreeningService.basicInfoForm.briefTitle" id="brief-title"
                            data-guide-id="screening.briefTitle" type="text"
                            placeholder="Screening Brief title" class="input-primary text-primary" />
                        @if (createScreeningService.basicInfoForm.briefTitle().touched() &&
                        createScreeningService.basicInfoForm.briefTitle().invalid()) {
                        <ul class="error-list">
                            @for (error of createScreeningService.basicInfoForm.briefTitle().errors(); track error) {
                            <li class="text-error-light flex items-start gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                    stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                    <path
                                        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                </svg>
                                {{ error.message }}
                            </li>
                            }
                        </ul>
                        }
                    </div>
                </div>



                <div class="sm:col-span-full">
                    <div class="flex flex-row items-center justify-between">
                        <div>
                            <label for="select" class="block text-sm/6 font-medium text-primary">Product to screen
                                for</label>
                            <p class="text-sm/6 text-secondary">When we screen creators, we'll be looking for this
                                product in their content.</p>
                        </div>
                        <div class="flex flex-row items-center gap-x-2">

                            <div class="grid grid-cols-1">
                                <input [formField]="productSearchQueryForm.query" id="product-search" type="text"
                                    placeholder="Product Search" class="input-icon text-primary" />
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 sm:size-4">
                                    <path d="m21 21-4.34-4.34" />
                                    <circle cx="11" cy="11" r="8" />
                                </svg>
                            </div>

                            <button type="button" [appTooltip]="'Add Product'" position="left"
                                class="fab-button-primary">
                                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                    class="size-5">
                                    <path
                                        d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    @if (allProducts()) {
                    <ul role="list"
                        class="mt-2 grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-4 sm:gap-x-6 lg:grid-cols-6 px-2">
                        @for (product of displayProducts(); track product.id) {
                        <li class="relative">
                            <div (click)="onProductSelect(product)"
                                class="aspect-10/7 group overflow-hidden rounded-lg bg-gray-800 focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary cursor-pointer flex items-center justify-center"
                                [class]="createScreeningService.selectedProduct()?.id === product.id ? 'outline-2 outline-offset-2 outline-primary' : ''">
                                @if (createScreeningService.selectedProduct()?.id === product.id) {
                                <div class="absolute right-2 top-2 text-green-500">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        class="size-6">
                                        <path fill-rule="evenodd"
                                            d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                            clip-rule="evenodd" />
                                    </svg>

                                </div>
                                }
                                <img [src]="imageService.getImageSource(product.productImage, 'gallery_xl')" alt=""
                                    class="pointer-events-none aspect-10/7 rounded-lg object-cover outline -outline-offset-1 outline-white/10 group-hover:opacity-75" />
                                <button type="button" class="absolute inset-0 focus:outline-hidden">
                                    <span class="sr-only">View details for IMG_4985.HEIC</span>
                                </button>
                            </div>
                            <p class="pointer-events-none mt-2 block truncate text-xs font-medium text-primary">{{
                                product.productName }}</p>
                        </li>
                        }
                    </ul>
                    }
                </div>



                <div class="sm:col-span-full">
                    <div>
                        <label for="select" class="block text-sm/6 font-medium text-primary">Would you like to add
                            additional product images?</label>
                        <p class="text-sm/6 text-secondary">Using our advanced models, adding brand logos and product
                            images will improve the quality of the screening.</p>
                    </div>
                    <div class="mt-2 grid grid-cols-6 gap-x-4 gap-y-4">
                        <div class="col-span-1">
                            <atom-add-image [bucket]="S3Bucket.PRODUCT_IMAGES" [clearOnUpload]="true"
                                (imageUploaded)="onImageUploaded($event)"></atom-add-image>
                        </div>
                        <div class="col-span-5">
                            <ul role="list"
                                class="grid grid-cols-3 gap-x-2 gap-y-4 sm:grid-cols-4 md:grid-cols-5 sm:gap-x-6 lg:grid-cols-6 xl:gap-x-8">
                                @for (image of displayAdditionalProductImages(); track image) {
                                <li class="relative">

                                    <button (click)="onImageDelete(image)" type="button"
                                        class="absolute -right-2 -top-2 z-10 fab-button-delete">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-4">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>

                                    <div class="flex-none rounded-lg bg-gray-50 overflow-hidden">
                                        <atom-ldg-img inputClass="object-cover aspect-10/7 rounded-lg object-cover"
                                            w="full" radius="md"
                                            [src]="imageService.getImageSource(image, 'gallery')"></atom-ldg-img>
                                    </div>


                                </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>




            </div>



        </div>
    </div>
</div>